<template>
  <div class="swiper-container" id="banner">
    <div class="slogan">
      <img src="../../../assets/img/banner/slogan.png" alt />
      <div class="btn" @click="delivery">ORDER NOW</div>
      <div class="number">Call: (906) 779 - 5588</div>
    </div>
    <div class="swiper-wrapper">
      <div class="swiper-slide">
        <img src="../../../assets/img/banner/banner (1).jpg" alt />
      </div>
      <div class="swiper-slide">
        <img src="../../../assets/img/banner/banner (2).jpg" alt />
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "Banner",
  props: {},
  data() {
    return {};
  },
  mounted() {
    new Swiper("#banner", {
      autoplay: true,
      pagination: {
        el: ".swiper-pagination",
        bulletActiveClass: "my-bullet-active",
        bulletClass: "my-bullet",
        clickable: true
      }
    });
  },
  components: {},
  methods: {
  delivery() {
      window.open("https://us.orderspoon.com/peking-chinese-restaurant")
    },
  }
};
</script>

<style scoped lang="scss">
.swiper-container {
  height: 28.242424rem;
  position: relative;
  @media screen and (max-width: 800px) {
    height: 20.242424rem;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .slogan {
    width: 31.909091rem;
    height: 1.666667rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    @media screen and (max-width: 800px) {
      width: 20rem;
    }

    .btn {
      background: #f4b336;
      color: #fff;
      width: 7.242424rem;
      height: 2.363636rem;
      text-align: center;
      margin: 2.363636rem auto 1rem auto;
      line-height: 2.363636rem;
      font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
      cursor: pointer;
      border-radius: 1.181818rem;
    }
    .number {
      text-align: center;
      font-size: 0.909091rem;
      font-family: Arial, Helvetica, sans-serif;
      color: #fff;
    }
  }
}
</style>
